import * as React from 'react';

import styles from './sidebar-user.module.css';

type Props = {
    canAccessSetup: boolean;
};

export class SidebarCompanyNameLogo extends React.PureComponent<Props> {
    render() {
        const companyName = NutClientConfig.instanceName;
        const companySlogan = NutClientConfig.companySlogan;

        return (
            <div className={styles['profile-info']}>
                {NutClientConfig.squareLogoUrl ? (
                    <img
                        style={{width: 48, height: 48, marginRight: 16}}
                        src={NutClientConfig.squareLogoUrl}
                    />
                ) : undefined}
                <div className={styles.info}>
                    <span className={styles.name}>{companyName}</span>
                    {companySlogan ? (
                        <span className={styles.email}>{companySlogan}</span>
                    ) : (
                        this.renderUploadLink()
                    )}
                </div>
            </div>
        );
    }

    renderUploadLink = () => {
        if (this.props.canAccessSetup) {
            return (
                <a href='/setup/index?sloganFocus=1' className={styles['slogan-link']}>
                    Add your company slogan
                </a>
            );
        }

        return null;
    };
}
